"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandedPackagingStatus = exports.BrandedPackagingError = exports.BrandedPackagingTypeName = exports.BrandedPackagingType = void 0;
var BrandedPackagingType;
(function (BrandedPackagingType) {
    BrandedPackagingType["BOX"] = "BOX";
    BrandedPackagingType["GIFT_WRAP"] = "GIFT_WRAP";
    BrandedPackagingType["INNER_BOX"] = "INNER_BOX";
    BrandedPackagingType["INSERTS"] = "INSERTS";
    BrandedPackagingType["PACK_SLIP"] = "PACK_SLIP";
    BrandedPackagingType["POLYBAG"] = "POLYBAG";
    BrandedPackagingType["STICKERS"] = "STICKERS";
    BrandedPackagingType["TAPE"] = "TAPE";
    BrandedPackagingType["TISSUE_PAPER"] = "TISSUE_PAPER";
})(BrandedPackagingType = exports.BrandedPackagingType || (exports.BrandedPackagingType = {}));
var BrandedPackagingTypeName;
(function (BrandedPackagingTypeName) {
    BrandedPackagingTypeName["BOX"] = "B";
    BrandedPackagingTypeName["GIFT_WRAP"] = "GW";
    BrandedPackagingTypeName["INNER_BOX"] = "IB";
    BrandedPackagingTypeName["INSERTS"] = "IT";
    BrandedPackagingTypeName["PACK_SLIP"] = "PS";
    BrandedPackagingTypeName["POLYBAG"] = "PB";
    BrandedPackagingTypeName["STICKERS"] = "S";
    BrandedPackagingTypeName["TAPE"] = "T";
    BrandedPackagingTypeName["TISSUE_PAPER"] = "TP";
})(BrandedPackagingTypeName = exports.BrandedPackagingTypeName || (exports.BrandedPackagingTypeName = {}));
var BrandedPackagingError;
(function (BrandedPackagingError) {
    BrandedPackagingError["INVALID_BRANDED_PACKAGING_DETAILS"] = "INVALID_BRANDED_PACKAGING_DETAILS";
    BrandedPackagingError["INVALID_BRANDED_PACKAGING_TYPE"] = "INVALID_BRANDED_PACKAGING_TYPE";
})(BrandedPackagingError = exports.BrandedPackagingError || (exports.BrandedPackagingError = {}));
var BrandedPackagingStatus;
(function (BrandedPackagingStatus) {
    BrandedPackagingStatus["AWAITING_APPROVAL"] = "AWAITING_APPROVAL";
    BrandedPackagingStatus["CANCELLED"] = "CANCELLED";
    BrandedPackagingStatus["FORWARDING"] = "FORWARDING";
    BrandedPackagingStatus["PROCESSING_PROOF"] = "PROCESSING_PROOF";
})(BrandedPackagingStatus = exports.BrandedPackagingStatus || (exports.BrandedPackagingStatus = {}));
//# sourceMappingURL=BrandedPackaging.js.map